import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function ciudadReducer(state= initialState.ciudad, action){
    let newState;
	switch(action.type){
         case types.LOAD_CIUDAD_LIST_SUCCESS:		
            action.ciudad.filtroActivo=state.filtroActivo;
            action.ciudad.filtroActual=state.filtroActual;
            action.ciudad.showActivos=state.showActivos;
			 action.ciudad.paginaActual=action.ciudad.pageable.pageNumber;
			 action.ciudad.registrosPorPagina=action.ciudad.size;
            
            return action.ciudad;

        case types.BORRAR_CIUDAD_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(ciudad => ciudad.id !== action.ciudad.id)];          
			return newState;    
            
        case types.ACTIVAR_CIUDAD_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(ciudad => ciudad.id !== action.ciudad.id)];          
			 return newState;
            
        case types.SET_FILTRO_CIUDAD:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}